import { TGetMyProductContractsResDto } from "@/api/services/main/product-contract/dtos/get-my-product-contracts.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { clientApi } from "@/utils/api";
import { useQuery } from "@tanstack/react-query";

export const fetchMyProductContractsApi = async (): Promise<TGetMyProductContractsResDto> => {
  const { data } = await clientApi.get<TGetMyProductContractsResDto>("/product-contracts");
  return data;
};

export const useMyProductContracts = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.PRODUCT_CONTRACT.FETCH_LIST],
    queryFn: () => fetchMyProductContractsApi(),
  });

  return { data: data?.data ?? [], ...rest };
};
